import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faEnvelope,
    faPaperPlane,
    faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../../context/AuthContext";
import apiClient from "../../api/client";
import "./Support.css";

const Support = () => {
    const { user } = useAuth();

    const [form, setForm] = useState({ service: "", message: "" });
    const [state, setState] = useState("idle");
    const [error, setError] = useState("");

    const handleChange = (e) =>
        setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

    const handleSubmit = async (e) => {
        e.preventDefault();
        setState("submitting");
        setError("");
        try {
            await apiClient.post("/contact", {
                name: user?.name || "",
                email: user?.email || "",
                company: user?.company || "",
                service: form.service || "General Support",
                message: form.message,
            });
            setState("success");
            setForm({ service: "", message: "" });
        } catch (err) {
            setState("error");
            setError(err.message || "Failed to send. Please try again.");
        }
    };

    return (
        <div className="support-page">
            <div className="support-page__header">
                <h1 className="support-page__title">Contact Support</h1>
                <p className="support-page__subtitle">
                    Reach out for help with your account, active projects, or
                    any technical questions.
                </p>
            </div>

            <div className="support-page__layout">
                {/* Contact info */}
                <div className="support-info">
                    <div className="support-info__item">
                        <div className="support-info__icon">
                            <FontAwesomeIcon icon={faEnvelope} />
                        </div>
                        <div>
                            <p className="support-info__label">Email</p>
                            <a
                                href="mailto:admin@kyle-street.com"
                                className="support-info__value"
                            >
                                admin@kyle-street.com
                            </a>
                        </div>
                    </div>
                </div>

                {/* Message form */}
                <div className="support-form-wrap">
                    <h2 className="support-form-wrap__title">Send a Message</h2>

                    {state === "success" ? (
                        <div className="support-success">
                            <FontAwesomeIcon icon={faCheckCircle} />
                            <p>Message sent — I'll follow up directly.</p>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit} noValidate>
                            <div className="form-group">
                                <label htmlFor="support-service">
                                    Subject / Topic
                                </label>
                                <select
                                    id="support-service"
                                    name="service"
                                    value={form.service}
                                    onChange={handleChange}
                                >
                                    <option value="">— Select a topic —</option>
                                    <option value="Account Access">Account Access</option>
                                    <option value="Invoice / Billing Question">Invoice / Billing Question</option>
                                    <option value="Project Update">Project Update</option>
                                    <option value="Technical Issue">Technical Issue</option>
                                    <option value="General Inquiry">General Inquiry</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <label htmlFor="support-message">
                                    Message <span className="required">*</span>
                                </label>
                                <textarea
                                    id="support-message"
                                    name="message"
                                    required
                                    rows={6}
                                    value={form.message}
                                    onChange={handleChange}
                                    placeholder="Describe your question or issue…"
                                />
                            </div>
                            {state === "error" && (
                                <div className="error-message">{error}</div>
                            )}
                            <button
                                type="submit"
                                className="btn btn--primary support-submit"
                                disabled={state === "submitting"}
                            >
                                <FontAwesomeIcon icon={faPaperPlane} />
                                {state === "submitting" ? "Sending…" : "Send Message"}
                            </button>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Support;
